import { render, staticRenderFns } from "./LevelSelector.vue?vue&type=template&id=8726e51c&scoped=true&"
import script from "./LevelSelector.vue?vue&type=script&lang=js&"
export * from "./LevelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LevelSelector.vue?vue&type=style&index=0&id=8726e51c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8726e51c",
  null
  
)

export default component.exports